import { get } from "lodash";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Navbar = ({ title, showBackBtn, sx, ...props }) => {
  const navigate = useNavigate();
  const justifyContent = get(sx, "justifyContent", "justify-content-between");
  const alignItems = get(sx, "alignItems", "align-items-center");

  return (
    <StyleWrapper
      {...props}
      className={`nav-bar rounded-box d-flex ${justifyContent} ${alignItems}`}
    >
      {showBackBtn && (
        <div className="nav-bar-back d-flex align-items-center">
          <button
            className="nav-bar-back-btn d-flex justify-content-center align-items-center"
            onClick={() => navigate(-1)}
          >
            <img src="/assets/icons/chevron-left.svg" alt="" />
          </button>
          Retour
        </div>
      )}
      {!!title && title}
      {/* <div className="nav-bar-action">
        <button className="nav-bar-action__btn">
          <img src="/assets/icons/notification.svg" alt="" />
        </button>
        <button className="nav-bar-action__btn">
          <img src="/assets/icons/settings.svg" alt="" />
        </button>
      </div> */}
    </StyleWrapper>
  );
};

const StyleWrapper = styled.header`
  padding: 25px 30px;

  .nav-bar-back-btn {
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    margin-right: 15px;
  }
  .nav-bar-back {
    flex-shrink: 0;
  }

  .nav-bar-action {
    display: flex;
    gap: 15px;
  }

  .nav-bar-action__btn {
    width: 53px;
    height: 53px;
    border: none;
    border-radius: 50%;
  }
`;

export default Navbar;
